import React, { useState, useEffect } from 'react';
import colors from '../../utils/colors';

const AnimatedCredits = ({ credits, className = "" }) => {
  const [displayCredits, setDisplayCredits] = useState(credits);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (credits !== displayCredits) {
      setIsAnimating(true);
      
      // Animate the number change
      const startValue = displayCredits;
      const endValue = credits;
      const duration = 800; // 800ms animation
      const startTime = Date.now();
      
      const animate = () => {
        const now = Date.now();
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);
        
        // Easing function for smooth animation
        const easeOut = 1 - Math.pow(1 - progress, 3);
        
        const currentValue = Math.round(startValue + (endValue - startValue) * easeOut);
        setDisplayCredits(currentValue);
        
        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          setIsAnimating(false);
        }
      };
      
      requestAnimationFrame(animate);
    }
  }, [credits, displayCredits]);

  // Format number with commas
  const formatCredits = (num) => {
    return num.toLocaleString();
  };

  // Determine text color based on credit amount
  const getTextColor = () => {
    if (displayCredits <= 50) {
      return colors.states.danger;
    }
    return '#faf7f5'; // Default white color
  };

  return (
    <span 
      className={`transition-all duration-300 ${isAnimating ? 'scale-110' : ''} ${className}`}
      style={{ 
        color: isAnimating ? colors.accent : getTextColor()
      }}
    >
      {formatCredits(displayCredits)}
    </span>
  );
};

export default AnimatedCredits;